import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Log pages
export const LogListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/logs/list')) as Promise<
      typeof import('@/pages/setting/logs/list')
    >
);

export const LogDetailPage = lazy(
  () =>
    retry(() => import('@/pages/setting/logs/detail')) as Promise<
      typeof import('@/pages/setting/logs/detail')
    >
);
